import React, { useState, useEffect } from "react";
import { Link, NavLink } from "react-router-dom";
import { getAccountInfo } from "../api/rest-apis";
import posthog from "posthog-js";

interface UserInfo {
  firstName: string;
  lastName: string;
  email: string;
}

const Header: React.FC = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [userInfo, setUserInfo] = useState<UserInfo>({
    firstName: "",
    lastName: "",
    email: "",
  });

  useEffect(() => {
    fetchUserInfo();
  }, []);

  const fetchUserInfo = async () => {
    try {
      const response: any = await getAccountInfo();
      setUserInfo({
        firstName:
          response.firstName.charAt(0).toUpperCase() +
          response.firstName.slice(1),
        lastName: response.lastName
          ? response.lastName.charAt(0).toUpperCase() +
            response.lastName.slice(1)
          : "",
        email: response.email,
      });
    } catch (error) {
      console.error(error);
    }
  };

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const handleMobileLogout = () => {
    if (localStorage.getItem("token")) {
      localStorage.clear();
      posthog.reset();
      window.location.href = `${process.env.REACT_APP_REST_API_URI}/logout`;
      return;
    }
    window.location.href = `${process.env.REACT_APP_REST_API_URI}/login`;
  };

  const handleLogin = () => {
    window.location.href = `${process.env.REACT_APP_REST_API_URI}/login`;
  };

  return (
    <div className="page-header">
      <div className="page-header">
        <Link to="/">
          <div className="logo">
            <img src="/assets/images/logo.png" alt="" />
          </div>
        </Link>

        <Link to="/">
          <h1 className="site-title">Bookish Boyfriend</h1>
        </Link>
      </div>

      {/* Login button for non-authenticated users */}
      {!localStorage.getItem("token") && (
        <button
          className="ml-4 hidden lg:flex items-center justify-center px-4 py-2 gap-2 bg-[var(--primary-color)] !text-white font-medium text-sm rounded-lg shadow-lg hover:bg-opacity-90 focus:ring-2 focus:ring-[var(--primary-color)] focus:ring-offset-2 transition duration-300 mr-4 cursor-pointer"
          onClick={handleLogin}
        >
          <span className="font-bold !text-white">Login</span>
          <img
            className="h-5 w-5"
            src="/assets/images/account-white.svg"
            alt="Account Icon"
          />
        </button>
      )}

      {/* Mobile Menu Toggle */}
      <div className="mobile-navigation cursor-pointer" onClick={toggleMobileMenu}>
        <img src="/assets/images/mobile-menu.svg" alt="" />
      </div>

      {/* Mobile Menu */}
      <div className={`${isMobileMenuOpen ? "mobile-menu" : "hidden"}`}>
        <div className="flex">
          <div className="page-header">
            <Link to="/">
              <div className="logo">
                <img src="/assets/images/logo.png" alt="" />
              </div>
            </Link>

            <Link to="/">
              <h1>Bookish Boyfriend</h1>
            </Link>
          </div>

          <div className="mobile-navigation cursor-pointer" onClick={toggleMobileMenu}>
            <img src="/assets/images/close-menu.svg" alt="" />
          </div>
        </div>

        <div
          className="flex flex-col justify-start gap-1 ml-4 mobile-menu-list"
          style={{ marginTop: ".5rem" }}
        >
          <NavLink to="/" onClick={toggleMobileMenu}>
            <div className="flex justify-start cursor-pointer p-4 w-[95%] mobile-navlink">
              <img src="/assets/images/home-white.svg" alt="" />
              <p className="align-center ml-8">Home</p>
            </div>
          </NavLink>

          <NavLink to="/chats" onClick={toggleMobileMenu}>
            <div className="flex justify-start cursor-pointer p-4 w-[95%] mobile-navlink">
              <img src="/assets/images/chats-white.svg" alt="" />
              <p className="align-center ml-8">Chats</p>
            </div>
          </NavLink>

          <NavLink to="/saved" onClick={toggleMobileMenu}>
            <div className="flex justify-start cursor-pointer p-4 w-[95%] mobile-navlink">
              <img src="/assets/images/saved-white.svg" alt="" />
              <p className="align-center ml-8">Saved</p>
            </div>
          </NavLink>

          <NavLink to="/price" onClick={toggleMobileMenu}>
            <div className="flex justify-start cursor-pointer p-4 w-[95%] mobile-navlink">
              <img src="/assets/images/bill-white.svg" alt="" />
              <p className="align-center ml-8">Pricing</p>
            </div>
          </NavLink>

          <a
            className="flex justify-start cursor-pointer p-4 w-[95%] mobile-navlink"
            href="https://community.bookishboyfriend.com/"
          >
            <img src="/assets/images/community.svg" alt="" />
            <p className="align-center ml-8">Community</p>
          </a>

          <NavLink to="/support" onClick={toggleMobileMenu}>
            <div className="flex justify-start cursor-pointer p-4 w-[95%] mobile-navlink">
              <img src="/assets/images/support-white.svg" alt="" />
              <p className="align-center ml-8">Support</p>
            </div>
          </NavLink>

          <NavLink to="/setting" onClick={toggleMobileMenu}>
            <div className="flex justify-start cursor-pointer p-4 w-[95%] mobile-navlink mb-4">
              <img src="/assets/images/setting-white.svg" alt="" />
              <p className="align-center ml-8">Settings</p>
            </div>
          </NavLink>

          <div className="absolute z-10 bg-[#F1F2ED] bottom-1 mb-2 user-info-bottom w-[90%]">
            {localStorage.getItem("token") && (
              <div className="flex justify-start cursor-pointer">
                <div className="user-first-letter-icon">
                  {userInfo.firstName.length > 0
                    ? userInfo.firstName.charAt(0)
                    : ""}
                </div>
                <div className="align-center ml-4">
                  <p>{userInfo.firstName + " " + userInfo.lastName}</p>
                  <p className="email-address">{userInfo.email}</p>
                </div>
              </div>
            )}

            <div
              className="flex justify-start items-end cursor-pointer"
              onClick={handleMobileLogout}
            >
              {localStorage.getItem("token") ? (
                <div
                  className="logout flex justify-center items-center p-1 mr-3 cursor-pointer mt-5"
                  style={{
                    border: "2px solid #D14444",
                    color: "#D14444 !important",
                    borderRadius: "5px",
                    width: "100%",
                  }}
                >
                  <img
                    className="h-[2rem]"
                    src="/assets/images/logout.svg"
                    alt=""
                  />
                  <p style={{ color: "#D14444", fontWeight: 600 }}>Logout</p>
                </div>
              ) : (
                <div
                  className="logout flex justify-center items-center p-1 mr-3 cursor-pointer mt-5"
                  style={{
                    border: "2px solid #36434D",
                    color: "#36434D !important",
                    borderRadius: "5px",
                    width: "100%",
                  }}
                >
                  <img
                    className="h-[2rem]"
                    src="/assets/images/account-whitesmoke.svg"
                    alt=""
                  />
                  <p style={{ color: "#36434D", fontWeight: 600 }}>Login</p>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
